import "./AddRoom.css";
import React, { Fragment } from "react";
import AddRoomViewModel from "./AddRoomViewModel";
import ButtonSpinner from "../../../../Components/Spinners/ButtonSpinner";
import IsSchoolAdded from "../../../../Hooks/IsSchoolAdded";

const AddRoom = () => {
  const {
    RegisterRoom,
    AddRoom,
    setAddRoom,
    HostelNameError,
    RoomNumberError,
    RoomTypeError,
    TotalBedsError,
    BedsAvailableError,
    CostPerBedError,
    FormDisabled,
    IsUpdate,
  } = AddRoomViewModel();

  const SchoolAddedResp = IsSchoolAdded();
  return (
    <Fragment>
      {/* Page Wrapper */}
      <div className="page-wrapper admin-add-room-page">
        <div className="content container-fluid">
          {/* Page Header */}
          <div className="page-header">
            <div className="row align-items-center">
              <div className="col">
                <h3 className="page-title">
                  {IsUpdate === true ? "Update Room" : "Add Room"}
                </h3>
                <ul className="breadcrumb">
                  <li className="breadcrumb-item">
                    <a href="hostel.html">Hostel</a>
                  </li>
                  <li className="breadcrumb-item active">
                    {IsUpdate === true ? "Update Room" : "Add Room"}
                  </li>
                </ul>
              </div>
            </div>
          </div>
          {/* /Page Header */}
          <div className="row">
            <div className="col-sm-12">
              <div className="card">
                <div className="card-body">
                  <form>
                    <div className="row">
                      <div className="col-12">
                        <h5 className="form-title">
                          <span>Room Information</span>
                        </h5>
                        {!SchoolAddedResp && (
                          <div className="add-school-first-container">
                            <svg
                              xmlns="http://www.w3.org/2000/svg"
                              width="20"
                              height="20"
                              fill="currentColor"
                              className="bi bi-exclamation-triangle-fill"
                              viewBox="0 0 16 16"
                            >
                              <path d="M8.982 1.566a1.13 1.13 0 0 0-1.96 0L.165 13.233c-.457.778.091 1.767.98 1.767h13.713c.889 0 1.438-.99.98-1.767L8.982 1.566zM8 5c.535 0 .954.462.9.995l-.35 3.507a.552.552 0 0 1-1.1 0L7.1 5.995A.905.905 0 0 1 8 5zm.002 6a1 1 0 1 1 0 2 1 1 0 0 1 0-2z" />
                            </svg>
                            <p>Please add school first!</p>
                          </div>
                        )}
                      </div>

                      <div className="col-12 col-sm-4">
                        <div className="form-group local-forms">
                          <label>
                            Hostel Name <span className="login-danger">*</span>
                          </label>
                          <input
                            className={`form-control ${
                              HostelNameError === true && "error-message"
                            }`}
                            type="text"
                            onChange={(e) => {
                              setAddRoom({
                                ...AddRoom,
                                HostelName: e.target.value.toLowerCase(),
                              });
                            }}
                            value={AddRoom.HostelName}
                            disabled={FormDisabled || !SchoolAddedResp}
                          />
                          {HostelNameError === true ? (
                            <span className="admin-add-room-tooltip">
                              <i className="fa-solid fa-info icon-after-submit"></i>
                              <span className="text-after-submit">
                                Hostel name is required and cannot be less than
                                3 characters.
                              </span>
                            </span>
                          ) : (
                            <span className="admin-add-room-tooltip">
                              <i className="fa-solid fa-info text-info"></i>
                              <span className="tooltip-text">
                                Hostel name is required and cannot be less than
                                3 characters.
                              </span>
                            </span>
                          )}
                        </div>
                      </div>

                      <div className="col-12 col-sm-4">
                        <div className="form-group local-forms">
                          <label>
                            Block <span className="login-danger">*</span>
                          </label>
                          <input
                            className="form-control"
                            type="text"
                            onChange={(e) => {
                              setAddRoom({
                                ...AddRoom,
                                Block: e.target.value,
                              });
                            }}
                            value={AddRoom.Block}
                            disabled={FormDisabled || !SchoolAddedResp}
                          />
                        </div>
                      </div>

                      <div className="col-12 col-sm-4">
                        <div className="form-group local-forms">
                          <label>
                            Room No <span className="login-danger">*</span>
                          </label>
                          <input
                            className={`form-control ${
                              RoomNumberError === true && "error-message"
                            }`}
                            type="text"
                            onChange={(e) => {
                              setAddRoom({
                                ...AddRoom,
                                RoomNumber: e.target.value,
                              });
                            }}
                            value={AddRoom.RoomNumber}
                            disabled={FormDisabled || !SchoolAddedResp}
                          />
                          {HostelNameError === true ? (
                            <span className="admin-add-room-tooltip">
                              <i className="fa-solid fa-info icon-after-submit"></i>
                              <span className="text-after-submit">
                                Room number is required.
                              </span>
                            </span>
                          ) : (
                            <span className="admin-add-room-tooltip">
                              <i className="fa-solid fa-info text-info"></i>
                              <span className="tooltip-text">
                                Room number is required.
                              </span>
                            </span>
                          )}
                        </div>
                      </div>

                      <div className="col-12 col-sm-4">
                        <div className="form-group local-forms">
                          <label>
                            Room Type <span className="login-danger">*</span>
                          </label>
                          <select
                            className={`form-control ${
                              RoomTypeError === true && "error-message"
                            }`}
                            onChange={(e) => {
                              setAddRoom({
                                ...AddRoom,
                                RoomType: e.target.value,
                              });
                            }}
                            value={AddRoom.RoomType}
                            disabled={FormDisabled || !SchoolAddedResp}
                          >
                            <option>Select Type</option>
                            <option value={"Normal"}>Normal</option>
                            <option value={"Medium"}>Medium</option>
                            <option value={"Large"}>Large</option>
                          </select>
                        </div>
                      </div>

                      <div className="col-12 col-sm-4">
                        <div className="form-group local-forms">
                          <label>
                            Total Beds <span className="login-danger">*</span>
                          </label>
                          <input
                            className={`form-control ${
                              TotalBedsError === true && "error-message"
                            }`}
                            type="number"
                            onChange={(e) => {
                              setAddRoom({
                                ...AddRoom,
                                TotalBeds: e.target.value * 1,
                              });
                            }}
                            value={AddRoom.TotalBeds}
                            disabled={FormDisabled || !SchoolAddedResp}
                          />
                          {TotalBedsError === true ? (
                            <span className="admin-add-room-tooltip">
                              <i className="fa-solid fa-info icon-after-submit"></i>
                              <span className="text-after-submit">
                                Total beds are is required.
                              </span>
                            </span>
                          ) : (
                            <span className="admin-add-room-tooltip">
                              <i className="fa-solid fa-info text-info"></i>
                              <span className="tooltip-text">
                                Total beds are is required.
                              </span>
                            </span>
                          )}
                        </div>
                      </div>

                      <div className="col-12 col-sm-4">
                        <div className="form-group local-forms">
                          <label>
                            Beds Available{" "}
                            <span className="login-danger">*</span>
                          </label>
                          <input
                            className={`form-control ${
                              BedsAvailableError === true && "error-message"
                            }`}
                            type="number"
                            onChange={(e) => {
                              setAddRoom({
                                ...AddRoom,
                                BedsAvailable: e.target.value * 1,
                              });
                            }}
                            value={AddRoom.BedsAvailable}
                            disabled={FormDisabled || !SchoolAddedResp}
                          />
                          {BedsAvailableError === true ? (
                            <span className="admin-add-room-tooltip">
                              <i className="fa-solid fa-info icon-after-submit"></i>
                              <span className="text-after-submit">
                                Available beds cannot be negative.
                              </span>
                            </span>
                          ) : (
                            <span className="admin-add-room-tooltip">
                              <i className="fa-solid fa-info text-info"></i>
                              <span className="tooltip-text">
                                Available beds cannot be negative.
                              </span>
                            </span>
                          )}
                        </div>
                      </div>

                      <div className="col-12 col-sm-4">
                        <div className="form-group local-forms">
                          <label>
                            Cost Per Bed <span className="login-danger">*</span>
                          </label>
                          <input
                            className={`form-control ${
                              CostPerBedError === true && "error-message"
                            }`}
                            type="number"
                            onChange={(e) => {
                              setAddRoom({
                                ...AddRoom,
                                CostPerBed: e.target.value * 1,
                              });
                            }}
                            value={AddRoom.CostPerBed}
                            disabled={FormDisabled || !SchoolAddedResp}
                          />
                          {CostPerBedError === true ? (
                            <span className="admin-add-room-tooltip">
                              <i className="fa-solid fa-info icon-after-submit"></i>
                              <span className="text-after-submit">
                                Cost per bed is required.
                              </span>
                            </span>
                          ) : (
                            <span className="admin-add-room-tooltip">
                              <i className="fa-solid fa-info text-info"></i>
                              <span className="tooltip-text">
                                Cost per bed is required.
                              </span>
                            </span>
                          )}
                        </div>
                      </div>

                      <div className="col-12">
                        <div className="student-submit">
                          <button
                            type="submit"
                            className="btn btn-primary"
                            onClick={(e) => {
                              e.preventDefault();
                              RegisterRoom();
                            }}
                            disabled={FormDisabled || !SchoolAddedResp}
                          >
                            {FormDisabled && <ButtonSpinner />}{" "}
                            {IsUpdate === true ? "Update " : "Submit"}
                          </button>
                        </div>
                      </div>
                    </div>
                  </form>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      {/* /Page Wrapper */}
    </Fragment>
  );
};

export default AddRoom;
